// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_text_btn-primary__1MG_H","section":"_text_section__1bJFR","p1":"_text_p1__1ELax","p2":"_text_p2__1sH2x","finePrint":"_text_finePrint__3KKpF"};